
// round to two decimal places
export const roundToTwo = (num) => {
    return +(Math.round(num + "e+2")  + "e-2");
}